import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function ExpenseItemActionMenu(props) {
    const { record, onApprove, onReject, onEdit, onDelete, my,onPay } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onExportAction = () => {
        props.onExport();
        setAnchorEl(null);
    }
    return (
        <div>
            <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}

            >
                Actions
            </Button>
            <StyledMenu
                id={"demo-customized-menu"+props.key}
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {record.status == 'pending' && props.my === "" && record.subStatus === undefined ?
                    <MenuItem onClick={() => onApprove(record.reimbursementId)} disableRipple>
                        <Button onClick={() => onApprove(record.reimbursementId)}>Approve</Button>
                    </MenuItem>

                    : (<div></div>)}


                {record.status == 'pending' && props.my === "my" ?
                    <MenuItem onClick={() => onEdit(record)} disableRipple>
                        <Button onClick={() => onEdit(record)}>Quick edit</Button>
                    </MenuItem>
                    : ''}


                {record.status == 'pending' && props.my === "" ?
                    <MenuItem onClick={() => onEdit(record)} disableRipple>
                        <Button onClick={() => onEdit(record)}>Quick edit</Button>
                    </MenuItem>
                    : ''}

                {record.status == 'pending' && props.my === "" ?
                    <MenuItem onClick={() => onReject(record.reimbursementId)} disableRipple>
                        <Button onClick={() => onReject(record.reimbursementId)}>Reject</Button>
                    </MenuItem>

                    : (<div></div>)}

                {record.status == 'pending' && props.my === "my" ?
                    <MenuItem onClick={() => onDelete(record)} disableRipple>
                        <Button onClick={() => { console.log(record.reimbursementId); onDelete(record); }}>Delete</Button>
                    </MenuItem>
                    : ''}

                {record.status == 'approved' && props.my === "" ?
                    <MenuItem onClick={() => onPay(record.reimbursementId)} disableRipple>
                        <Button onClick={() => { console.log(record.reimbursementId); onPay(record.reimbursementId); }}>Pay</Button>
                    </MenuItem>
                    : ''}

            </StyledMenu>
        </div>
    );
}
